import { aboutHeadingStyle, aboutTitleStyle, aboutBodyStyle } from '../../../../styles/aboutTextStyles';

export const missionVisionTextBlockStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: {xs: "10px", lg: "24px"},
    paddingLeft: {xs: "20px", lg: "75px"},
    paddingRight: {xs: "20px", lg: "75px"},
    width: "100%",
  },
  heading: aboutHeadingStyle,
  title: aboutTitleStyle,
  body: aboutBodyStyle,
};


